module.exports = __webpack_public_path__ + "img/3_hillstate.eaf3bde4.png";